/*******************************************************
 *
 * FileIcon.jsx
 *
 *******************************************************/

import React from "react";

export default function FileIcon({ fileName, size = "2rem" }) {

    //----------------------------------------------------
    // Aucun fichier
    //----------------------------------------------------

    if (!fileName) {

        return (
            <i
                className="bi bi-file-earmark"
                style={{ fontSize: size }}
            />
        );

    }

    //----------------------------------------------------
    // Extension
    //----------------------------------------------------

    const extension =
        fileName
            .substring(fileName.lastIndexOf("."))
            .toLowerCase();

    //----------------------------------------------------
    // Valeurs par défaut
    //----------------------------------------------------

    let icon = "bi-file-earmark-fill";

    let color = "text-secondary";

    //----------------------------------------------------
    // Images
    //----------------------------------------------------

    if (

        [

            ".jpg",
            ".jpeg",
            ".png",
            ".gif",
            ".webp",
            ".bmp",
            ".svg"

        ].includes(extension)

    ) {

        icon = "bi-file-image-fill";
        color = "text-info";

    }

    //----------------------------------------------------
    // Vidéos
    //----------------------------------------------------

    else if (

        [

            ".mp4",
            ".webm",
            ".ogg",
            ".mov",
            ".avi",
            ".mkv"

        ].includes(extension)

    ) {

        icon = "bi-file-play-fill";
        color = "text-danger";

    }

    //----------------------------------------------------
    // PDF
    //----------------------------------------------------

    else if (extension === ".pdf") {

        icon = "bi-file-earmark-pdf-fill";
        color = "text-danger";

    }

    //----------------------------------------------------
    // WORD
    //----------------------------------------------------

    else if (

        [

            ".doc",
            ".docx"

        ].includes(extension)

    ) {

        icon = "bi-file-earmark-word-fill";
        color = "text-primary";

    }

    //----------------------------------------------------
    // EXCEL
    //----------------------------------------------------

    else if (

        [

            ".xls",
            ".xlsx",
            ".csv"

        ].includes(extension)

    ) {

        icon = "bi-file-earmark-excel-fill";
        color = "text-success";

    }

    //----------------------------------------------------
    // POWERPOINT
    //----------------------------------------------------

    else if (

        [

            ".ppt",
            ".pptx"

        ].includes(extension)

    ) {

        icon = "bi-file-earmark-ppt-fill";
        color = "text-warning";

    }

    //----------------------------------------------------
    // ZIP / RAR
    //----------------------------------------------------

    else if (

        [

            ".zip",
            ".rar",
            ".7z",
            ".tar",
            ".gz"

        ].includes(extension)

    ) {

        icon = "bi-file-earmark-zip-fill";
        color = "text-dark";

    }

    //----------------------------------------------------
    // AUDIO
    //----------------------------------------------------

    else if (

        [

            ".mp3",
            ".wav",
            ".aac",
            ".ogg"

        ].includes(extension)

    ) {

        icon = "bi-file-music-fill";
        color = "text-success";

    }

    //----------------------------------------------------
    // TEXTE
    //----------------------------------------------------

    else if (

        [

            ".txt",
            ".xml",
            ".json",
            ".yaml",
            ".yml"

        ].includes(extension)

    ) {

        icon = "bi-file-earmark-text-fill";
        color = "text-secondary";

    }

    //----------------------------------------------------
    // CODE SOURCE
    //----------------------------------------------------

    else if (

        [

            ".java",
            ".js",
            ".jsx",
            ".ts",
            ".tsx",
            ".html",
            ".css",
            ".scss",
            ".sql",
            ".php",
            ".py",
            ".c",
            ".cpp"

        ].includes(extension)

    ) {

        icon = "bi-file-code-fill";
        color = "text-primary";

    }

    //----------------------------------------------------
    // Retour
    //----------------------------------------------------

    return (

        <i

            className={`bi ${icon} ${color}`}

            style={{

                fontSize: size

            }}

        />

    );

}